import { omit } from 'lodash-es';

import { BASE_SIZE } from '../constant';

export const COLOR_PICKER_SIZE = omit(BASE_SIZE, ['LG', 'MD']);
